import React from 'react'
import { Cell } from 'rsuite-table'
import './DescriptionCell.scss'

type RowData = {
  [key: string]: any
}

type DescriptionCellProps = {
  rowData?: RowData,
  dataKey: string
}

const DescriptionCell: React.FC<DescriptionCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const description = rowData?.[dataKey]

  return (
    <Cell {...props}>
      <div className="scrollable-description">{description || '-'}</div>
    </Cell>
  )
}

export default DescriptionCell
